module.exports = __webpack_public_path__ + "static/media/34DSS9.098627c9.jpg";